var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
      'ui-input',
      {
        'is-disabled': _vm.disabled,
      }
    ]},[_c('input',_vm._b({ref:"input",staticClass:"ui-input__inner",class:_vm.inputClass,style:(_vm.inputStyle),attrs:{"type":"file","id":_vm.computedId,"disabled":_vm.disabled},on:{"input":_vm.handleInput,"change":_vm.handleChange,"blur":_vm.handleBlur}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }